import { GlobeAltIcon, ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

const SERVERS = [
    { label: 'Borne V1', href: 'https://0.wg.graphcom.fr', desc: 'Serveur Wireguard bornes V1' },
    { label: 'ALTA', href: 'https://1.wg.graphcom.fr', desc: 'Serveur Wireguard parc Alta' },
    { label: 'GRAPHCOM', href: 'https://2.wg.graphcom.fr', desc: 'Serveur Wireguard Graphcom' },
];

function Wireguard() {
    return (
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
            <div className="mb-6">
                <h1 className="text-2xl font-bold text-slate-800">Wireguard</h1>
                <p className="text-sm text-slate-500">Accès aux consoles VPN du parc.</p>
            </div>

            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {SERVERS.map((s) => (
                    <a
                        key={s.href}
                        href={s.href}
                        target="_blank"
                        rel="noreferrer"
                        className="group flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-lg"
                    >
                        <div className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-violet-500/10 text-violet-600">
                            <GlobeAltIcon className="h-6 w-6" />
                        </div>
                        <div className="min-w-0 flex-1">
                            <h3 className="text-sm font-semibold text-slate-800">{s.label}</h3>
                            <p className="mt-0.5 text-xs text-slate-400">{s.desc}</p>
                        </div>
                        <ArrowTopRightOnSquareIcon className="h-5 w-5 shrink-0 text-slate-300 transition group-hover:text-violet-500" />
                    </a>
                ))}
            </div>
        </div>
    );
}

export default Wireguard;
